<app-preloader></app-preloader>
<app-sidebar></app-sidebar>
<router-outlet></router-outlet>
<app-footer></app-footer>
<ngx-scrolltop></ngx-scrolltop>